import { httpDelete, httpGet, httpPost } from "../remoteDataProvider"
import { AssociationId } from "../../types"

export async function createNewBatch(association: AssociationId, payload: any, token: string) {
  try {
    console.log("createNewBatch payload:", payload)
    const response = await httpPost("people_flow_core", `/asynctasks/${association}`, payload, token)
    console.log("createNewBatch response:", response)
    return response.data
  } catch (error) {
    console.log("createNewBatch error:", error)
    throw error
  }
}

export async function getBatches(association: AssociationId, type: string, token: string) {
  try {
    const response = await httpGet("people_flow_core", `/asynctasks/type/${type}/${association}`, token)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function deleteBatch(association: AssociationId, taskId: string, token: string) {
  try {
    const response = await httpDelete("people_flow_core", `/asynctasks/taskid/${taskId}/${association}`, token)
    return response.data
  } catch (error) {
    throw error
  }
}
